export const HSG_HEALTH_INDEX_ASSESSMENT_ID =
  process.env.NODE_ENV === 'development'
    ? '290e3475044bf96d6c29243fdc8c4feb22611f7b'
    : '290e3475044bf96d6c29243fdc8c4feb22611f7b'
